import { defineMessages } from 'react-intl-next';

export default defineMessages({
    unifiedHelpSearchTitle: {
        defaultMessage: 'Get help from teams in your organization',
        description: 'Message shown above the search bar on a Unified Help Center.',
        id: 'unified-help.search.title',
    },
    unifiedHelpSearchSubtitle: {
        defaultMessage:
            'Unified Help brings all of your organization’s resources to your fingertips using the power of AI',
        description: 'Subtitle for Unified Help search.',
        id: 'unified-help.search.subtitle',
    },
    unifiedHelpSearchPlaceholder: {
        defaultMessage: 'Ask any question, like “How do I connect to the VPN?”',
        description: 'Placeholder text for Unified Help search.',
        id: 'unified-help.search.placeholder',
    },
    unifiedHelpSearchPlaceholderInConversation: {
        defaultMessage: 'Ask another question',
        description: 'Placeholder text for Unified Help search, in conversation mode',
        id: 'unified-help.search.conversation.placeholder',
    },
    allConnectedAppsSuccess: {
        defaultMessage: 'You’ve signed in to all connected apps on Unified Help',
        description: 'Title for all connected apps success flag',
        id: 'unified-help.connected.apps.all.success',
    },
    allConnectedAppsButton: {
        defaultMessage: 'Got it',
        description: 'Title for all connected apps button text',
        id: 'unified-help.connected.apps.all.button',
    },
});
